// extracted by mini-css-extract-plugin
module.exports = {"social-links":"social-links_social-links__s_7Kr","linkedin":"social-links_linkedin__3xUV3","behance":"social-links_behance__3QAwt"};